import React from 'react';

const Row = ({ data }) => {
    const td = data.map(value => <td>{value}</td>);

    return (<tr>{td}</tr>);
}

export default Row;


// WEBPACK FOOTER //
// ./src/scenes/BidderWinRateConfig/components/FactorsTable/components/Row/index.js